import * as React from 'react';
import { random } from 'oasis-os-utils';
import { doc, register } from './Hypervisor';
const Context = React.createContext(undefined);
function Provider({ id, config, children, app: loadedApp, initial, }) {
    const route = document?.location?.pathname || '/';
    // Register the app on the first run.
    // Using useState init function is a trick that will help us avoid further re-registrations
    const [registeredApp] = React.useState(() => {
        if (id === 'root' && !!doc()) {
            // Are there two root? :alarm:
            id = random();
            if (process.env.NODE_ENV === 'development') {
                console.error('A root is being nested under an existing tenant. This is dangerous because it can create data corruption.');
            }
        }
        if (!id) {
            // No ID? oO!
            if (!doc()) {
                // Let's see if this is the root (tenant).
                id = 'root';
            }
            else {
                // Did contentful ID not get through?
                // That's fine, we can generate a random ID.
                id = random();
            }
            // And now let the developer know that the ID may be missing
            if (process.env.NODE_ENV === 'development') {
                console.warn('Did you forget to forward properties to App from your FeatureApp component?');
                console.warn('We assigned a random ID to this instance', id);
            }
        }
        // Register the app on first run
        return register(id, {
            route,
            config,
            data: initial,
            id: config?.id,
            name: loadedApp?.name,
            meta: loadedApp,
            tokens: {
            // todo: any tokens that may be needed in the future
            // this is usually important to come from the root doc
            },
        });
    });
    const [app] = React.useState(registeredApp);
    // If initial data changes via props, then save it to app.data
    React.useEffect(() => {
        if (initial && app) {
            app.data = initial;
        }
    }, [initial]);
    return React.createElement(Context.Provider, { value: app }, children);
}
export default Provider;
export { Context };
